
<footer class="bg-gray-100 text-sm text-black py-12 border-t border-t-primary-500">
    <div class="container mx-auto px-4 flex flex-col items-center space-y-12">
        <!-- Logo -->
        <div class="w-full flex items-center justify-center md:justify-start mb-4">
            <a href="https://purso.fi/">
                <img src="https://purso.fi/wp-content/uploads/2024/10/pursologo24.svg"
                     alt="{{ 'FOOTER.PURSO' | translate }}"
                     class="h-10" />
            </a>
        </div>

        <!-- Neljä saraketta: käytetään gridiä, joka on grid-cols-2 alle md ja grid-cols-4 md+:llä -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8 w-full max-w-6xl text-center md:text-left">
            <!-- Sarake 1: Yhteystiedot ja some -->
            <div class="space-y-4 order-1 md:order-none">
                <div>
                    <p>{{ 'FOOTER.ADDRESS' | translate }}</p>
                    <a href="tel:+35833404111" class="text-primary hover:underline block">
                        {{ 'FOOTER.PHONE' | translate }}
                    </a>
                    <a href="mailto:purso@purso.fi" class="text-primary hover:underline block">
                        {{ 'FOOTER.EMAIL' | translate }}
                    </a>
                </div>
                <div>
                    <a href="https://purso.fi/laskutustiedot/" class="text-primary hover:underline">
                        {{ 'FOOTER.BILLING_INFORMATION' | translate }}
                    </a>
                </div>
                <div class="flex justify-center md:justify-start space-x-4 mt-4">
                    <a href="https://www.facebook.com/purso.fi/" aria-label="Facebook" class="text-primary hover:text-blue-800">
                        <svg class="h-6 w-6 fill-current" aria-hidden="true" viewBox="0 0 16 28">
                            <path d="M14.984.187v4.125h-2.453c-1.922 0-2.281.922-2.281 2.25v2.953h4.578l-.609 4.625H10.25v11.859H5.469V14.14H1.485V9.515h3.984V6.109C5.469 2.156 7.891 0 11.422 0c1.687 0 3.141.125 3.563.187z"></path>
                        </svg>
                    </a>
                    <a href="https://www.linkedin.com/company/purso-oy" aria-label="LinkedIn" class="text-primary hover:text-blue-800">
                        <svg class="h-6 w-6 fill-current" aria-hidden="true" viewBox="0 0 26 28">
                            <path d="M6.232 11.161v17.696H.339V11.161h5.893zm.375-5.465Q6.625 7 5.705 7.875t-2.42.875h-.036q-1.464 0-2.357-.875t-.893-2.179q0-1.321.92-2.188t2.402-.866 2.375.866.911 2.188zm20.822 13.018v10.143h-5.875v-9.464q0-1.875-.723-2.938t-2.259-1.063q-1.125 0-1.884.616t-1.134 1.527q-.196.536-.196 1.446v9.875H9.483q.036-7.125.036-11.554t-.018-5.286l-.018-.857h5.875v2.571h-.036q.357-.571.732-1t1.009-.929 1.554-.777 2.045-.277q3.054 0 4.911 2.027t1.857 5.938z"></path>
                        </svg>
                    </a>
                    <a href="https://www.instagram.com/pursobuildingsystems" aria-label="Instagram" class="text-primary hover:text-blue-800">
                        <svg class="h-6 w-6 fill-current" aria-hidden="true" viewBox="0 0 26 28">
                            <path d="M16 14c0-2.203-1.797-4-4-4s-4 1.797-4 4 1.797 4 4 4 4-1.797 4-4zm2.156 0c0 3.406-2.75 6.156-6.156 6.156S5.844 17.406 5.844 14 8.594 7.844 12 7.844s6.156 2.75 6.156 6.156zm1.688-6.406c0 .797-.641 1.437-1.437 1.437S16.97 8.39 16.97 7.594s.641-1.437 1.437-1.437 1.437.641 1.437 1.437zM12 4.156c-1.75 0-5.5-.141-7.078.484-.547.219-.953.484-1.375.906s-.688.828-.906 1.375c-.625 1.578-.484 5.328-.484 7.078s-.141 5.5.484 7.078c.219.547.484.953.906 1.375s.828.688 1.375.906c1.578.625 5.328.484 7.078.484s5.5.141 7.078-.484c.547-.219.953-.484 1.375-.906s.688-.828.906-1.375c.625-1.578.484-5.328.484-7.078s.141-5.5-.484-7.078c-.219-.547-.484-.953-.906-1.375s-.828-.688-1.375-.906C17.5 4.015 13.75 4.156 12 4.156zM24 14c0 1.656.016 3.297-.078 4.953-.094 1.922-.531 3.625-1.937 5.031s-3.109 1.844-5.031 1.937c-1.656.094-3.297.078-4.953.078s-3.297.016-4.953-.078c-1.922-.094-3.625-.531-5.031-1.937S.173 20.875.08 18.953C-.014 17.297.002 15.656.002 14s-.016-3.297.078-4.953c.094-1.922.531-3.625 1.937-5.031s3.109-1.844 5.031-1.937c1.656-.094 3.297-.078 4.953-.078s3.297-.016 4.953.078c1.922.094 3.625.531 5.031 1.937s1.844 3.109 1.937 5.031C24.016 10.703 24 12.344 24 14z"></path>
                        </svg>
                    </a>
                </div>
            </div>

            <!-- Sarake 2: Navigaatio osa 1 -->
            <div class="space-y-2 order-3 md:order-none">
                <ul class="space-y-1">
                    <li>
                        <a href="https://purso.fi/" class="hover:text-primary">
                            {{ 'FOOTER.HOME' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/profiilit-ja-komponentit/" class="hover:text-primary">
                            {{ 'FOOTER.PROFILES_COMPONENTS' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/rakentaminen/" class="hover:text-primary">
                            {{ 'FOOTER.BUILDING' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/valaistus/" class="hover:text-primary">
                            {{ 'FOOTER.LIGHTING' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/purso/" class="hover:text-primary">
                            {{ 'FOOTER.COMPANY' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/ajankohtaista/" class="hover:text-primary">
                            {{ 'FOOTER.LATEST_DEVELOPMENTS' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/referenssit/" class="hover:text-primary">
                            {{ 'FOOTER.REFERENCES' | translate }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Sarake 3: Navigaatio osa 2 -->
            <div class="space-y-2 order-4 md:order-none">
                <ul class="space-y-1">
                    <li>
                        <a href="https://purso.fi/yhteystiedot/" class="hover:text-primary">
                            {{ 'FOOTER.CONTACT_DETAILS' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/toimipisteet/" class="hover:text-primary">
                            {{ 'FOOTER.OFFICE_LOCATIONS' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/purso/ura-pursolla/" class="hover:text-primary">
                            {{ 'FOOTER.RECRUITMENT' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/purso/vastuullisuus-pursolla/" class="hover:text-primary">
                            {{ 'FOOTER.SUSTAINABILITY' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/eettiset-ohjeet/" class="hover:text-primary">
                            {{ 'FOOTER.ETHICAL_GUIDELINES' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/whistleblowing-ilmoituskanava/" class="hover:text-primary">
                            {{ 'FOOTER.WHISTLEBLOWING' | translate }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Sarake 4: Kielet ja tietosuoja -->
            <div class="space-y-2 order-2 md:order-none">
                <ul class="space-y-1">
                    <li>
                        <a href="#" (click)="translateService.use('fi')" class="hover:text-primary font-semibold">
                            {{ 'FOOTER.LANGUAGE_FI' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="#" (click)="translateService.use('en')" class="hover:text-primary">
                            {{ 'FOOTER.LANGUAGE_EN' | translate }}
                        </a>
                    </li>
                </ul>
                <ul class="mt-4 space-y-1">
                    <li>
                        <a href="https://purso.fi/tietosuojaseloste/" class="text-primary hover:underline">
                            {{ 'FOOTER.PRIVACY_POLICY' | translate }}
                        </a>
                    </li>
                    <li>
                        <a href="https://purso.fi/evasteseloste/" class="text-primary hover:underline">
                            {{ 'FOOTER.COOKIE_POLICY' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Logot -->
        <div class="flex flex-wrap justify-center gap-8">
            <img src="https://purso.fi/wp-content/uploads/2023/02/snep-by-purso-logo-rgb-musta.png"
                 alt="SNEP"
                 class="h-10 object-contain" />
            <img src="https://purso.fi/wp-content/uploads/2023/12/purso-greenline.png"
                 alt="SNEP"
                 class="h-10 object-contain" />
            <img src="https://purso.fi/wp-content/uploads/2023/12/eco-by-purso-logo-rgb-vihrea.png"
                 alt="ECO"
                 class="h-10 object-contain" />
            <img src="https://purso.fi/wp-content/uploads/2021/11/osaamista-suomesta-sininen-rgb.png"
                 alt="Osaamista Suomesta"
                 class="h-10 object-contain" />
        </div>
    </div>
</footer>
